<script setup>
import ThreeDotsSvg from "@/components/UI/svg/ThreeDotsSvg.vue";
import { defineProps, defineModel, defineEmits } from 'vue'
import { useRouter } from "vue-router";


const router = useRouter()

const emits = defineEmits(['startConnection', 'delete-connection', 'open-summary'])


const isVisible = defineModel()

const props = defineProps({
    workflowId: {
        type: String,
        required: true,
    },
    connectionId: {
        type: String,
        required: true,
    }
})

function closeDropdown() {
    isVisible.value = false
}

function openDropdown() {
    isVisible.value = true
}

function deleteConnection() {
    emits('delete-connection', props.connectionId)
}

function redirectToUpdate() {
    router.push({name: "ConnectionUpdate", params: {workflow_id: props.workflowId, connection_id: props.connectionId}})
}

function openSummary() {
    emits('open-summary', props.connectionId)
}
</script>

<template>
    <div class="flex size-10 justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer relative"
         v-on:click="openDropdown"
         v-click-outside="closeDropdown"
    >
        <ThreeDotsSvg class="size-6" />
        <div class="flex flex-col min-w-40 bg-white shadow-2xl rounded-md absolute z-30 -right-3 -top-0 transition-all duration-200"
             :class="{
                'opacity-0 invisible': !isVisible,
                'opacity-100 visible': isVisible
            }"
        >
            <div class="py-3 px-3 border-b hover:bg-gray-100 text-black transition-all duration-300" v-on:click="emits('startConnection')">
                Запустить
            </div>
            <div class="py-3 px-3 border-b hover:bg-gray-100 text-black transition-all duration-300"
                 v-on:click="redirectToUpdate"
            >
                Изменить
            </div>
            <div class="py-3 px-3 border-b hover:bg-gray-100 text-black transition-all duration-300"
                 v-on:click="openSummary"
            >
                Сводка
            </div>
            <div class="py-3 px-3 border-b hover:bg-gray-100 text-black transition-all duration-300"
                 v-on:click="deleteConnection"
            >
                Удалить
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>